import { Icon } from '@chakra-ui/react';

export const GrowthIcon = (props = { color: '#1A1A1A' }) => (
  <Icon viewBox="0 0 35 35" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.9582 11.6667C18.1528 11.6667 17.4998 11.0137 17.4998 10.2083C17.4998 9.40292 18.1528 8.75 18.9582 8.75H30.6248C31.4303 8.75 32.0832 9.40292 32.0832 10.2083V21.875C32.0832 22.6804 31.4303 23.3333 30.6248 23.3333C29.8194 23.3333 29.1665 22.6804 29.1665 21.875V13.7291L19.9894 22.9062C19.4199 23.4757 18.4965 23.4757 17.927 22.9062L13.1248 18.1041L5.40603 25.8229C4.83652 26.3924 3.91315 26.3924 3.34364 25.8229C2.77413 25.2534 2.77413 24.33 3.34364 23.7605L12.0936 15.0105C12.6632 14.441 13.5865 14.441 14.156 15.0105L18.9582 19.8126L27.1041 11.6667H18.9582Z"
      fill="currentColor"
    />
  </Icon>
);
